import * as angular from 'angular';

const WINDOW_PADDING = 20;

const selectHeightDirective = function ($window, $timeout) {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function ($scope: any, element, attrs, dropdownCtrl) {
      const maxHeight = parseInt(attrs.selectHeight, 10);

      const resize = (offset?: number) => {
        if (!element.hasClass('dropdown-open')) {
          return;
        }
        const padding = offset ? WINDOW_PADDING + offset : WINDOW_PADDING;
        if (
          element.offset().top + element.height() + padding > $window.innerHeight ||
          element.hasClass('auto-height-resize')
        ) {
          element.addClass('auto-height-resize');
          let newHeight = $window.innerHeight - element.offset().top - padding;
          if (maxHeight) {
            newHeight = Math.min(newHeight, maxHeight);
          }

          if (newHeight >= element.height()) {
            element.height('auto');
            element.removeClass('auto-height-resize');
            if (element.offset().top + element.height() + padding > $window.innerHeight) {
              // still to big
              element.height(newHeight);
              element.addClass('auto-height-resize');
            }
          } else {
            element.height(newHeight);
          }
        }
      };

      $scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
        if (isOpen) {
          $timeout(() => resize(10)); // dropdown opens with a translate 10px
        }
      });

      const handleResize = () => resize();

      angular.element($window).on('resize', handleResize);
      element.on('multiselect-resize', handleResize);

      $scope.$on('$destroy', function () {
        angular.element($window).off('resize', handleResize);
        element.off('multiselect-resize', handleResize);
      });
    },
  };
};

selectHeightDirective.$inject = ['$window', '$timeout'];

angular.module('mode.components').directive('selectHeight', selectHeightDirective);
